import React from 'react'

const VARIANT_CLASSES = {
  primary: 'bg-rb-green text-white dark:text-rb-dark-mode border-rb-green',
  secondary: 'bg-white dark:bg-rb-dark-mode text-rb-black dark:text-white border-border-primary dark:border-rb-dark-mode-lighter hover:bg-gray-100 dark:hover:bg-rb-dark-mode-lighter',
  subtle: 'bg-gray-200 dark:bg-rb-dark-mode-lighter text-rb-black dark:text-white border-transparent hover:bg-gray-300 dark:hover:bg-rb-dark-mode',
  cancel: 'rb-btn-cancel border-transparent',
  outlinePrimary:
    'border-rb-green bg-white text-rb-green shadow-sm hover:bg-rb-soft-green dark:border-rb-green dark:bg-rb-dark-mode dark:text-white dark:hover:bg-rb-dark-mode-lighter',
}

const SIZE_CLASSES = {
  sm: 'text-sm px-3 py-1.5',
  md: 'text-base px-4 py-2',
  lg: 'text-lg px-4 py-2',
}

export default function Button({
  children,
  className = '',
  disabled = false,
  onClick,
  size = 'md',
  type = 'button',
  variant = 'primary',
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded-lg border-1 font-semibold text-center active:shadow-outer ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${disabled ? 'rb-disabled' : ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}
